import React from "react";

export const PieEquinoVaro = (props) => {
  return (
    <div id="liquors">
      <div className="container">
        <div className="row">
          
          <div className="col-xs-12 col-md-6">
            <div className="liquors-text">
              <h2>Proyecto de Pie equinovaro</h2>
              <h3>2018-2025 </h3>
                <h3>Área de Interés: Salud Materno Infantil</h3>
              <div className="text-justify">
                <div className="col-lg-12 col-sm-12 col-xs-12">
                  <p>
                   El pie equino varo (¨Pie Chapín”) es la deformidad congénita musculo esquelética más frecuente.
                  Se calcula que, para la población colombiana, nacen alrededor de800 niños al año con la deformidad y en el mundo nace uno cada
3 minutos. El tratamiento de estos niños era hasta hace pocomediante cirugías extensas y con
resultados funcionales a largo plazo no siempre exitosos. El pie equino varo no tratado lleva a pobreza, aislamiento y los niños son víctimas de abuso.
Actualmente el método de Ponseti es reconocido universalmente como el tratamiento de elección en los niños que nacen con esta enfermedad. Es un método sencillo, económico y que
permite corrección completa de la deformidad, pero requiere un conocimiento muy detallado de la técnica por parte de los ortopedistas, para tener los resultados
que reporta la literatura mundial. 
</p><p>El método de Ponseti consiste en manipulaciones, seguidas de colocación de yeso semanal por aproximadamente 5 a 7 sema-
nas, dependiendo de la rigidez del pie; luego una mínima intervención sobre el tendón de aquiles con anestesia local (tenotomía) y posteriormente el uso de una férula nocturna que mantiene la corrección del pie mientras el niño
crece. La literatura recomienda usarla los 5 primeros años de vida del niño.
Gracias al método de Ponseti, los niños tienen la posibilidad de vivir el resto de su vida sin discapacidad y con una función normal de sus pies.
                  </p>
                  <p>Los invitamos a visitar el siguiente link para aprender mas sobre el método ponseti:
                    <a href="https://youtube.com/@ponseticolombiaoficial?si=CxbglYoTpXAWTZ2g" target="_blank" > Ponseti oficial Colombia</a>
                  </p>
                </div>
                
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/ponseti.jpg" className="img-responsive" alt="" />{" "}
          </div>
        </div>
      </div>
    </div>
  );
};
